import { isArray } from 'util';
import { Subcategory } from '../subcategory';

export class SubcategoryBuilder {
  static fromJson(json) {
    return (json)
      ? new Subcategory(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(SubcategoryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/subcategory.builder.ts